<template>
  <container-small>
      <background-wrapper :src="$toKebabCase($route.name) + '/fullscreen-image_lets-get'" ext="png" align="top">
        <div class="lets-get">
          <text-container size="lg">
            <h2 class="h1 text-white">{{$t('products.lets-get.title')}}</h2>
            <b-btn variant="primary" :to="{ name: 'RequestDemo' }">
              {{$t(`products.${$route.name}.lets-get.btn-text`)}}
            </b-btn>
          </text-container>
        </div>
      </background-wrapper>
    </container-small>
</template>

<script>
export default {
  name: 'LetsGet',
  props: {
    title: String,
    btnText: String
  }
}
</script>

<style lang="sass" scoped>
.lets-get
  margin-top: -220px
  padding-top: 520px
  padding-bottom: 120px
  +media-breakpoint-down(md)
    padding-top: 400px
  +media-breakpoint-down(sm)
    margin-top: 0px
    padding-top: 300px
    padding-bottom: 50px
  +media-breakpoint-down(xs)
    padding-bottom: 80px
</style>



// WEBPACK FOOTER //
// src/components/ui/products/LetsGet.vue